// extracted by mini-css-extract-plugin
export var columnList = "_fw-0";